import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ReportCont } from './Report.styles';
import ReportDetails from '../../components/ReportDetails/ReportDetails';
import EffectReportDetails from '../../components/ReportLayout/EffectReportDetails/EffectReportDetails';
import ReportLayout from '../../components/ReportLayout/ReportLayout';
import { useReports } from '../../hooks/useReports';
import { IGetReportDetailsResp } from '../../services/reports';

const Report = () => {
  const { reportId } = useParams();
  const { getReportDetails } = useReports();
  const [searchParams] = useSearchParams();
  const surveyType = searchParams.get('surveyType');

  const [details, setDetails] = useState<IGetReportDetailsResp | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const details = await getReportDetails(reportId || '0');

        if (details) {
          setDetails(details);
        }
      } catch (error) {
        // TODO: handle errors
      }
    })();
  }, []);

  if (!details) {
    return null;
  }

  const renderDetails = () => {
    switch (surveyType) {
      case 'EFFECT':
        return <EffectReportDetails />;
      case 'ADAPT':
      case 'PULSE':
      default:
        return <ReportDetails />;
    }
  };

  return (
    <ReportCont id="ReportCont">
      <ReportLayout details={details}>{renderDetails()}</ReportLayout>
    </ReportCont>
  );
};

export default Report;
